export default __webpack_public_path__ + "static/media/santa-maria-4.8b68a451.jpg";